<div (focus)='setPointer()' (blur)='setOutOfFocus()' [ngStyle]="{ 'display' : this.procedureAssessmentsController.active? 'block' : 'none'}" [ngClass]="tabsService.minimizeScreenMode ? 'bottom-menu minimized' : ''">
  <div class="loading" [ngClass]="this.procedureAssessmentsController.loading? 'active' : ''">
    <div></div>
  </div>

  <form autocomplete="off"  id="ngProcedureAssessmentsController" [ngClass]="[this.procedureAssessmentsController.active ? 'active' : '',  tabsService.fullScreenMode ? 'fullscreen' : '']" name="ngProcedureAssessmentsController" #ngProcedureAssessmentsController="ngForm" id="procedureAssessmentsForm" style="height: 600px">
  <div class="fields__block">
    <div class="fields__block__section">
      <div class="title">
        <h4>CP Reposition and Direct To</h4>
        <span> </span>
      </div>
      <div class="table-fields">
        <div style="max-height: 200px; overflow-y: scroll;">
            <table>
              <thead>
                <tr>
                  <th scope="col">#</th>
                  <th scope="col">Id</th>
                  <th scope="col">Type</th>
                  <th scope="col">Name</th>
                  <th scope="col">Latitude [deg]</th>
                  <th scope="col">Longitude [deg]</th>
                  <th scope="col"></th>
                  <th scope="col"></th>
                </tr>
              </thead>
              <tbody>
                <tr mdbTableCol *ngFor="let el of procedureAssessmentsController.procedureInterfaceToHTML.procedureCoordinatePoints | sort:'sequencenumber'; let i = index;"
                (click)="procedureAssessmentsController.selectCoordinatePointService.selectProcedureAssessmentCoordinatePointRow(procedureAssessmentsController.procedureInterfaceToHTML.procedureCoordinatePoints[i], procedureAssessmentsController.procedureInterfaceToHTML.procedureCoordinatePoints); deselectFixPoint()"
                [class.highlighted]="el.coordPoint.isselected" [ngStyle]="{'background-color': el.isDeletedFromMap? 'red' : '', 'font-weight': el.coordPoint.ismodified? 'bold' : '' }" (change)="checkIfChange(el.coordPoint, i)" >
                  <td>{{i}}</td>
                  <td>{{ el.coordPoint.coordpointid }}</td>
                  <td>{{ el.coordPoint.type }}</td>
                  <td>{{ el.coordPoint.name }}</td>
                  <td><input type="number" [(ngModel)]="el.coordPoint.latitude" id="latitude:{{i}}" name="latitude_{{i}}"  value="{{ el.coordPoint.latitude }}"  (blur)="updateProcedureCoordPoint($event)" [ngStyle]="{'font-weight': el.coordPoint.ismodified? 'bold' : ''  }" /> </td>
                  <td><input type="number" [(ngModel)]="el.coordPoint.longitude" id="longitude:{{i}}" name="longitude_{{i}}"  value="{{ el.coordPoint.longitude }}" (blur)="updateProcedureCoordPoint($event)" [ngStyle]="{'font-weight': el.coordPoint.ismodified? 'bold' : ''  }" /></td>
                  <td>
                    <label for="" class="scissors"
                    (click)="isRedirectAllowed(i) ? redirectProcedure(el):false"> </label>
                  </td>
                  <td>
                    <label for="" class="transfer" (click)="resetEspecificCoordinatePoint(el)"></label>
                  </td>
                </tr>
                <tr mdbTableCol *ngFor="let el of procedureAssessmentsController.fixPoints | sort:'sequencenumber'; let i = index;"
                (click)="procedureAssessmentsController.selectCoordinatePointService.selectProcedureCoordinatePointRow(procedureAssessmentsController.fixPoints[i], procedureAssessmentsController.fixPoints); deselectProcedureCoordinatePoint()"
                [class.highlighted]="el.coordPoint.isselected" [ngStyle]="{'background-color': el.isDeletedFromMap? 'red' : '', 'font-weight': el.coordPoint.ismodified? 'bold' : '' }">
                  <td>{{i}}</td>
                  <td>{{ el.coordPoint.coordpointid }}</td>
                  <td>{{ el.coordPoint.type }}</td>
                  <td>{{ el.coordPoint.name }}</td>
                  <td><input type="number" [(ngModel)]="el.coordPoint.latitude" id="latitudeFixPoint:{{i}}" name="latitudeFixPoint_{{i}}"  value="{{ el.coordPoint.latitude }}"  (blur)="updateFixPoint($event)" [ngStyle]="{'font-weight': el.coordPoint.ismodified? 'bold' : ''  }" /> </td>
                  <td><input type="number" [(ngModel)]="el.coordPoint.longitude" id="longitudeFixPoint:{{i}}" name="longitudeFixPoint_{{i}}"  value="{{ el.coordPoint.longitude }}" (blur)="updateFixPoint($event)" [ngStyle]="{'font-weight': el.coordPoint.ismodified? 'bold' : ''  }" /></td>
                  <td>
                    <label for="" class="scissors"> </label>
                  </td>
                  <td>
                    <label for="" class="transfer" (click)="resetEspecificFixPoint(el)"></label>
                  </td>
                </tr>
              </tbody>
            </table>

          </div>
          <div>
            <div class="btn" style="cursor: default; padding: 10px 0;">
              <div class="labels" style="padding: 10px 0;">
                <label for="" class="scissors">Directo To: </label>
                <label for="" class="transfer"> Reset Position: </label>
              </div>
              <div>
                <a (click)="checkIfSave()? saveProcedure() : false">Save Procedure</a>
                <a (click)="resetPositions()"> Reset Positions</a>
                <a (click)="resetRedirectTo()"> reset All Direct To</a>
              </div>
            </div>
          </div>
      </div>
      </div>
    </div>
  <div class="fields__block">
    <div class="fields__block__section">
      <div class="title">
        <h4>Procedure Offset</h4>
        <span> </span>
      </div>
      <div class="table-fields">
        <div style="max-height: 200px; overflow-y: scroll;">
            <table>
              <thead>
                <tr>
                  <th scope="col">#</th>
                  <th scope="col">Origin Coordinate Point [ID: Name]</th>
                  <th scope="col">Destination Coordinate Point [ID: Name]</th>
                  <th scope="col">Offset [NM]</th>
                  <th scope="col">Direction</th>
                  <th scope="col"></th>
                </tr>
              </thead>
              <tbody>
                <tr mdbTableCol *ngFor="let el of procedureAssessmentsController.procedureInterfaceToHTML.procedureLegs | sort:'sequencenumber'; let i = index;"
                (click)="!el.ismodified? procedureAssessmentsController.selectCoordinatePointService.selectProcedureLegRow(el, procedureAssessmentsController.procedureInterfaceToHTML.procedureLegs) : false"
                    [class.highlighted]="el.isselected" [ngStyle]="{'background-color': el.ismodified? 'grey' : '', 'font-style': el.ismodified? 'italic' : ''}" [disabled]="el.ismodified">
                  <td>{{i}}</td>
                  <td>{{ el.startPoint.coordPoint.coordpointid}} : {{el.startPoint.coordPoint.name}}</td>
                  <td>{{ el.endPoint.coordPoint.coordpointid }} : {{el.endPoint.coordPoint.name}}</td>
                  <td>
                    <input type="number" id="offsetValue_{{i}}" name="offsetValue_{{i}}" min="0" value={{el.offset}} [(ngModel)]="el.offset" (blur)="updateOffset($event, i)" [disabled]="el.ismodified"/>
                  </td>
                  <td>
                    <select name="offsetDirection_{{i}}" id="offsetDirection_{{i}}" [(ngModel)]="el.direction" (blur)="updateOffset($event, i)" [disabled]="el.ismodified">
                      <option value="NotSet">Not Set</option>
                      <option value="Right">Right</option>
                      <option value="Left">Left</option>
                    </select>
                  </td>
                  <td>
                    <label for="" class="rubber" [class.selected]="el.isSelected == true" (click)="resetEspecificOffset($event, el)"></label>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div>
            <div class="btn" style="cursor: default; ">
              <div class="labels">
                <label for="" class="rubber">Reset Offset: </label>
              </div>
              <div>
                <a a (click)="resetOffsets()">Reset Offsets</a>
              </div>
            </div>
          </div>
      </div>
    </div>
    <div class="fields__block__section">
      <div class="title">
        <h4>Calculations</h4>
        <span> </span>
      </div>
      <div class="table-fields">
        <div>
            <div class="btn" style="cursor: default; padding: 0;">
              <div style="padding: 0;">
                <a (click)="openPerformanceAnalysisPopup()">Performance Analysis</a>
                <a (click)="openVerticalProfilePopup()">Calculate Vertical Profile</a>
              </div>
            </div>
        </div>
      </div>
    </div>
  </div>
  </form>
</div>
